// extracted by mini-css-extract-plugin
export default {"loading":"Canvas_loading__U1Jsu"};